export const RECEIPT_UPLOAD_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const RECEIPT_UPLOAD_SUPPORTED_MIME_TYPES = [
  'application/pdf',
  'image/heic',
  'image/heif',
  'image/jpeg',
  'image/jpg',
  'image/png',
] as const;

const supportedReceiptUploadMimeTypes = new Set<string>(RECEIPT_UPLOAD_SUPPORTED_MIME_TYPES);

export type ReceiptUploadFileMetadata = {
  mimeType: string;
  sizeBytes: number | null | undefined;
};

export const isSupportedReceiptUploadFile = ({ mimeType, sizeBytes }: ReceiptUploadFileMetadata): boolean => {
  return (
    supportedReceiptUploadMimeTypes.has(mimeType.toLowerCase()) &&
    typeof sizeBytes === 'number' &&
    sizeBytes >= 0 &&
    sizeBytes <= RECEIPT_UPLOAD_MAX_FILE_SIZE_BYTES
  );
};
